import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import superChatActions from 'ai/actions/superChatActions';
import EN from 'ai/components/SuperChat/locales/SuperChat_en_US.js';
import FR from 'ai/components/SuperChat/locales/SuperChat_fr_CA.js';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(EN, FR);

const localization = createStructuredSelector({
    addToBasket: getTextFromResource(getText, 'addToBasket'),
    added: getTextFromResource(getText, 'added'),
    free: getTextFromResource(getText, 'free'),
    points: getTextFromResource(getText, 'points')
});

const functions = {
    addRewardToBasket: superChatActions.addRewardToBasket,
    closeSuperChat: superChatActions.closeSuperChat
};

const fields = createSelector(localization, locales => ({
    localization: locales
}));

const withRewardCardProps = wrapHOC(connect(fields, functions));

export {
    withRewardCardProps, fields, functions
};
